import type {
  GetCreditAccountQuery,
  GetCreditAccountQueryVariables,
} from "@src/__generated__/graphql";
import type { TRefetch } from "@src/utils/apolloHelpers";
import { makeObservable, observable } from "mobx";
import type { BrandCreditAccountModel } from "./models";

export class StoreCreditAccount {
  refetch?: TRefetch<GetCreditAccountQueryVariables, GetCreditAccountQuery>;

  @observable.ref creditAccount?: BrandCreditAccountModel;

  constructor() {
    makeObservable(this);
  }

  static create() {
    return new StoreCreditAccount();
  }
}
